<template>
   <div class="popularity">
    <div class="dividing-line"></div>
    <div class="btn-outer-wrapper">
      <div class="tip">积攒人气还剩{{ popularity }}天，快邀请朋友为你打call</div>
      <Button :btnConfig="btnConfig"/>
    </div>
  </div>
</template>

<script>
import Button from '../../common/button'
import { getNowTime } from '@/common/utils/xesFunction.js'
import eventBus from '@/summerCamp/utils/bus'

export default {
  name: 'popularity',
  components: {
    Button
  },
  props: {
    activityInfo: {
      type: Object,
      default() {
        return {}
      }
    },
    personalArtical: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      btnConfig: {
        btnText: '邀请好友助力',
        fn: () => {
          this.toSharePoster(0)
        }
      },
      curPeriod: 0,
      popularity: ''
    }
  },
  watch: {
    activityInfo: {
      async handler() {
        this.curPeriod = this.activityInfo.period.filter(item => +item.status === 1)
        await this.getPopularity()
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    async getPopularity() {
      let dis = 0
      if (this.curPeriod.length) {
        const time = await getNowTime()
        let endDate = this.curPeriod[0].end_date
        // 要替换成-，否则移动端兼容有问题
        endDate = new Date(endDate.replace(/-/g, '/'))
        dis = (+endDate - (+time)) / 1000 / (3600 * 24)
        dis = Math.ceil(dis)
        dis = dis < 0 ? 0 : dis
      }
      this.popularity = dis
    },
    /**
     * 分享海报
     * @param type 0：邀请好友助力 1：分享
     */
    toSharePoster(type) {
      const articleId = this.personalArtical.artical_id
      eventBus.$emit('share-poster', { type, articleId })
    }
  }
}
</script>
<style lang="less" scoped>
.popularity {
  .dividing-line {
    position: relative;
    width: 89%;
    height: 1px;
    margin: 10px auto 50px;
    text-align: center;
    background: #f2dccd;

    &::before,
    &::after {
      position: absolute;
      top: 0;
      width: 12px;
      height: 12px;
      background: #ca0808;
      border-radius: 50%;
      content: '';
    }

    &::before {
      left: 0;
      transform: translate3d(-55%, -50%, 0);
    }

    &::after {
      right: 0;
      transform: translate3d(55%, -50%, 0);
    }
  }

  .btn-outer-wrapper {
    position: relative;
    display: inline-block;

    .tip {
      position: absolute;
      bottom: 120%;
      right: 30px;
      padding: 5px;
      font-size: 11px;
      font-weight: 400;
      color: #a5725c;
      background: #ffedda;
      border: 1px solid #ffdcdc;
      box-shadow: 0 0 11px 0 rgba(255, 200, 88, 0.5);

      &::before,
      &::after {
        position: absolute;
        right: 5%;
        transform: translateX(-50%);
        content: ' ';
      }

      &::before {
        top: 100%;
        border-left: 6px solid transparent;
        border-right: 6px solid transparent;
        border-top: 8px solid #ffdcdc;
      }

      &::after {
        top: 95%;
        border-left: 6px solid transparent;
        border-right: 6px solid transparent;
        border-top: 8px solid #fff3d6;
      }
    }
  }
}
</style>
